import React, { useState } from "react";
import {
  Row,
  Col,
  Container,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

// Import selectors & action from setting store
import * as SettingSelector from "../../../store/setting/selectors";
// Redux Selector / Action
import { useSelector } from "react-redux";

// Import auth service
import { authService, memberService } from "../../../services/api";

//img
import rsLogo from "../../../assets/images/rs_logo.png";
import login1 from "../../../assets/images/login/1.jpg";
import login2 from "../../../assets/images/login/2.jpg";
import login3 from "../../../assets/images/login/3.jpg";

// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

const SignIn = () => {
  const navigate = useNavigate();
  const appName = useSelector(SettingSelector.app_name);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("danger");
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData({
      ...formData,
      [name]: name === "rememberMe" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setIsLoading(true);

    try {
      // Call the API to authenticate the user
      await authService.login(formData.username, formData.password);

      // Clear RouteGuard cache to ensure fresh validation after login
      if (typeof window !== "undefined" && window.routeGuardClearCache) {
        window.routeGuardClearCache();
      }

      // Check member profile for password change requirement
      try {
        const profileResponse = await memberService.getProfile();

        // Check if response status is 423 (Password change required)
        if (
          profileResponse.status === 423 ||
          (profileResponse.data &&
            profileResponse.data.message === "Password change required")
        ) {
          // Redirect to change password page
          setAlertVariant("warning");
          setAlertMessage(
            "Password change required. Redirecting to change password page...",
          );
          setShowAlert(true);

          setTimeout(() => {
            navigate("/change-password", {
              state: { passwordChangeRequired: true },
            });
          }, 1000);
          return;
        }
      } catch (profileError) {
        // Check if the error is HTTP 423 (Password change required)
        if (profileError.response && profileError.response.status === 423) {
          // Redirect to change password page
          setAlertVariant("warning");
          setAlertMessage(
            "Password change required. Redirecting to change password page...",
          );
          setShowAlert(true);

          setTimeout(() => {
            navigate("/change-password", {
              state: { passwordChangeRequired: true },
            });
          }, 1000);
          return;
        }

        // If it's a different error, continue with normal login flow
        console.warn(
          "Failed to fetch member profile, proceeding with normal login:",
          profileError,
        );
      }

      // Successful login without password change requirement
      setAlertVariant("success");
      setAlertMessage("เข้าสู่ระบบสำเร็จ กำลังนำคุณไปยังหน้าแดชบอร์ด");
      setShowAlert(true);

      // Redirect after a short delay
      setTimeout(() => {
        navigate("/portal/summary");
      }, 1000);
    } catch (error) {
      // Failed login
      setAlertVariant("danger");
      setAlertMessage(
        error.response?.data?.message ||
          "อีเมลหรือรหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
      );
      setShowAlert(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="sign-in-page">
        <Container fluid>
          <Row className="align-items-center">
            <Col md={6} className="overflow-hidden position-relative">
              <div className="bg-primary w-100 h-100 position-absolute top-0 bottom-0 start-0 end-0"></div>
              <div className="container-inside z-1">
                <div className="main-circle circle-small"></div>
                <div className="main-circle circle-medium"></div>
                <div className="main-circle circle-large"></div>
                <div className="main-circle circle-xlarge"></div>
                <div className="main-circle circle-xxlarge"></div>
              </div>
              <div className="sign-in-detail container-inside-top">
                <Swiper
                  className="list-inline m-0 p-0 "
                  spaceBetween={30}
                  centeredSlides={true}
                  loop={true}
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                  }}
                >
                  <ul className="swiper-wrapper list-inline m-0 p-0 ">
                    <SwiperSlide>
                      <img
                        src={login1}
                        className="signin-img img-fluid mb-5 rounded-3"
                        alt="images"
                      />
                      <h2 className="mb-3 text-white fw-semibold">
                        Power UP Your Friendship
                      </h2>
                      <p className="font-size-16 text-white mb-0">
                        It is a long established fact that a reader will be
                        <br /> distracted by the readable content.
                      </p>
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        src={login2}
                        className="signin-img img-fluid mb-5 rounded-3"
                        alt="images"
                      />
                      <h2 className="mb-3 text-white fw-semibold">
                        Connect with the world
                      </h2>
                      <p className="font-size-16 text-white mb-0">
                        It is a long established fact that a reader will be
                        <br /> distracted by the readable content.
                      </p>
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        src={login3}
                        className="signin-img img-fluid mb-5 rounded-3"
                        alt="images"
                      />
                      <h2 className="mb-3 text-white fw-semibold">
                        Together Is better
                      </h2>
                      <p className="font-size-16 text-white mb-0">
                        It is a long established fact that a reader will be
                        <br /> distracted by the readable content.
                      </p>
                    </SwiperSlide>
                  </ul>
                </Swiper>
              </div>
            </Col>
            <Col md={6}>
              <div className="sign-in-from text-center">
                <Link
                  to="/"
                  className="d-inline-flex align-items-center justify-content-center gap-2"
                >
                  <img
                    src={rsLogo}
                    alt="RS Logo"
                    width="50"
                    className="img-fluid"
                  />
                  <h2 className="logo-title" data-setting="app_name">
                    {appName}
                  </h2>
                </Link>
                {/* <p className="mt-3 font-size-16">
                  Welcome to socialV, a platform to connect with
                  <br /> the social world
                </p> */}
                {showAlert && (
                  <Alert
                    variant={alertVariant}
                    className="mb-4"
                    onClose={() => setShowAlert(false)}
                    dismissible
                  >
                    {alertMessage}
                  </Alert>
                )}

                <Form
                  className="mt-5"
                  noValidate
                  validated={validated}
                  onSubmit={handleSubmit}
                >
                  <Form.Group className="form-group text-start">
                    <h6 className="form-label fw-bold">
                      Username or Email Address
                    </h6>
                    <Form.Control
                      type="text"
                      className="form-control mb-0"
                      placeholder="Your Email or Username"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter your username or email
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group text-start">
                    <h6 className="form-label fw-bold">Your Password</h6>
                    <Form.Control
                      type="password"
                      className="form-control mb-0"
                      placeholder="Password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter your password
                    </Form.Control.Feedback>
                  </Form.Group>
                  <div className="d-flex align-items-center justify-content-between">
                    <Form.Check className="form-check d-inline-block m-0">
                      <Form.Check.Input
                        type="checkbox"
                        className="form-check-input"
                        name="rememberMe"
                        checked={formData.rememberMe}
                        onChange={handleChange}
                      />
                      <h6 className="form-check-label fw-bold">Remember Me</h6>
                    </Form.Check>
                    <Link to="/forgot-password" className="font-italic">
                      Forgot Password?
                    </Link>
                  </div>
                  <Button
                    variant="primary"
                    type="submit"
                    className="btn btn-primary mt-4 fw-semibold text-uppercase w-100"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Loading...
                      </>
                    ) : (
                      "Sign in"
                    )}
                  </Button>
                  <div className="text-center mt-4">
                    <a
                      href="https://ruaysure.com/privacy-policy.html"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary"
                    >
                      Privacy Policy
                    </a>
                  </div>
                  <div className="text-center mt-3">
                    <Link to="/admin/login" className="text-muted small">
                      เข้าสู่ระบบแอดมิน →
                    </Link>
                  </div>
                  {/* <h6 className="mt-5">
                    Don't Have An Account ?{" "}
                    <Link to="/register">Sign Up</Link>
                  </h6> */}
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SignIn;
